import React, { useEffect, useRef, useState } from "react"
import TopSectionPrescriptionAudit from "../components/TopSectionPrescriptionAudit"
import UserDetailsForm from "../components/UserDetailsForm"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { getMetarxProjectService } from "../services/apiServices"
import { BiError } from "react-icons/bi";
import { AppLocalStorage } from "../services/contracts"

function PrescriptionAudit() {
  const [formValue, setFormValue] = useState("")
  const [otpErrorMessage, setOtpErrorMessage] = useState("")
  const [isEmail, setIsEmail] = useState(false)
  const [disabledForm, setDisabledForm] = useState(false)
  const [userId, setUserId] = useState(undefined)
  const [directPrescription, setDirectPrescription] = useState(false)
  const [metarxDetails, setMetarxDetails] = useState({})
  const [metarxErrorMessage, setMetarxErrorMessage] = useState('')

  const userDetailsRef = useRef(null)
  const { metarxId } = useParams()

  let savedUserId = localStorage.getItem("userId")

  useEffect(() => {
    if (metarxId) {
      setMetarxErrorMessage('')
      getMetarxProject()
    }
  }, [metarxId])

  const getMetarxProject = () => {
    getMetarxProjectService(metarxId).then(response => {
      setMetarxDetails(response.metarx)
    }).catch(error => {
      if (error.response?.data?.message) {
        setMetarxErrorMessage(error.response.data.message)
        AppLocalStorage.deleteAll()
      }
      console.error(error)
    })
  }

  useEffect(() => {
    if (disabledForm && userDetailsRef?.current) {
      userDetailsRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      })
    }
  }, [userDetailsRef, disabledForm])

  useEffect(() => {
    if (savedUserId && savedUserId.trim() && !disabledForm) {
      setUserId(savedUserId.trim())
      setDisabledForm(true)
      setDirectPrescription(true)
    }
  }, [savedUserId, disabledForm])


  return (
    <div>
      <TopSectionPrescriptionAudit
        setOtpErrorMessage={setOtpErrorMessage}
        isEmail={isEmail}
        setIsEmail={setIsEmail}
        formValue={formValue}
        setFormValue={setFormValue}
        disabledForm={disabledForm}
        setDisabledForm={setDisabledForm}
        setUserId={setUserId}
        userDetailsRef={userDetailsRef}
        metarxDetails={metarxDetails}
      />
      {disabledForm && <UserDetailsForm otpErrorMessage={otpErrorMessage} isEmail={isEmail} userDetailsRef={userDetailsRef} parentData={formValue} userId={userId} setUserId={setUserId} directPrescription={directPrescription} metarxDetails={metarxDetails} />}

      {metarxErrorMessage !== '' && <div className="metarx-error"><div className="metarx-error-message"><BiError />{metarxErrorMessage}</div></div>}
    </div>
  )
}

export default PrescriptionAudit
